import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import translate from "../../../i18n/translate";
import { chargeJawwal } from "../../../actions/companiesAction";
import Badge from "../../ui/Badge/Badge";
import JawwalPlusCard from "./JawwalPlusCard";
import { isEmpty, isNil, set } from "lodash";
import Button from "@mui/material/Button";
import useIsMobile from "shared/hooks/useIsMobile";
import { noBalanceContext } from "../../../reducers/no_balance";
import { useContext } from "react";
import { getLastTransaction } from "actions/reportsAction";
import { useDispatch, useSelector } from "react-redux";
import { setNumberChanged } from "../../../actions/companiesAction";
import BoltIcon from "@mui/icons-material/Bolt";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import Spinner from "components/ui/spinner/Spinner";
import { useIsRtl } from "shared/hooks/ppHooks";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-hot-toast";
import { ShowToastPromise } from "components/common/ShowToastPromise";
import ConfirmModal from "../shared/InfoModal";
import "./SelectedAnimations.css";

const Selected = ({
  min,
  setMin,
  g3,
  setg3,
  credit,
  setCredit,
  creditQueue = [],
  onCreditQueueChange,
  setRom,
  rom,
  chargeJawwal,
  isDarkTheme,
}) => {
  const IS_MOBILE_DISPLAY = useIsMobile();
  const noBalanceCtx = useContext(noBalanceContext);
  const history = useHistory().location.pathname;
  const pushHistory = useHistory();
  const [loadingSpinner, isLoading] = useState(false);
  const [openInfoModel, setOpenInfoModel] = useState(false);
  const [chargeType, setChargeType] = useState();
  const isRtL = useIsRtl();
  const dispatch = useDispatch();
  const pathname = history.split("/");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const creditCards = Array.isArray(creditQueue) ? creditQueue : [];
  const selectedCards = [
    ...creditCards,
    min,
    g3,
    rom,
  ].filter((card) => card && !isEmpty(card));
  const numberFromQuery = queryParams.get("number") || "";
  const numberIsChanged = useSelector(
    (state) => state.companies.numberIsChanged
  );
  const [quickProcessLoading, setQuickProcessLoading] = useState(false);

  const updateCreditQueue = (queue) => {
    if (typeof onCreditQueueChange === "function") {
      onCreditQueueChange(queue);
    } else {
      setCredit(queue[queue.length - 1] || "");
      if (queue?.length) {
        sessionStorage.JawwalCreditQueue = JSON.stringify(queue);
        sessionStorage.JawwalCredit = JSON.stringify(
          queue[queue.length - 1] || {}
        );
      } else {
        sessionStorage.removeItem("JawwalCreditQueue");
        sessionStorage.removeItem("JawwalCredit");
      }
    }
  };

  const removeSingleCredit = (uid) => {
    if (!uid) {
      updateCreditQueue([]);
      return;
    }
    updateCreditQueue(creditCards.filter((card) => card.__uid !== uid));
  };
  const [animatedItems, setAnimatedItems] = useState({
    credit: false,
    min: false,
    g3: false,
    rom: false,
  });

  const [flipTransforms, setFlipTransforms] = useState({
    credit: '',
    min: '',
    g3: '',
    rom: '',
  });

  // Track new items for animation
  const prevItems = useRef({ credit, min, g3, rom });
  const cardRefs = useRef({
    credit: null,
    min: null,
    g3: null,
    rom: null,
  });

  // Calculate FLIP animation
  const calculateFlipAnimation = (type, sourceElement) => {
    if (!sourceElement) return;

    // Get source position
    const sourceRect = sourceElement.getBoundingClientRect();

    // Wait for next frame to get target position
    requestAnimationFrame(() => {
      const targetElement = cardRefs.current[type];
      if (!targetElement) return;

      const targetRect = targetElement.getBoundingClientRect();

      // Calculate transform
      const deltaX = sourceRect.left - targetRect.left;
      const deltaY = sourceRect.top - targetRect.top;
      const scaleX = sourceRect.width / targetRect.width;
      const scaleY = sourceRect.height / targetRect.height;

      // Set CSS variable for animation
      setFlipTransforms(prev => ({
        ...prev,
        [type]: `translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY})`
      }));

      // Trigger animation
      setAnimatedItems(prev => ({ ...prev, [type]: true }));

      // Reset after animation
      setTimeout(() => {
        setAnimatedItems(prev => ({ ...prev, [type]: false }));
        setFlipTransforms(prev => ({ ...prev, [type]: '' }));
      }, 600);
    });
  };

  useEffect(() => {
    // Store calculation function in window for bundle components to call
    window.triggerBundleAnimation = (type, sourceElement) => {
      calculateFlipAnimation(type, sourceElement);
    };

    return () => {
      delete window.triggerBundleAnimation;
    };
  }, []);

  useEffect(() => {
    const newAnimated = { ...animatedItems };

    if (credit && credit !== prevItems.current.credit && !window.bundleAnimationTriggered) {
      newAnimated.credit = true;
      setTimeout(() => setAnimatedItems(prev => ({ ...prev, credit: false })), 800);
    }
    if (min && min !== prevItems.current.min && !window.bundleAnimationTriggered) {
      newAnimated.min = true;
      setTimeout(() => setAnimatedItems(prev => ({ ...prev, min: false })), 800);
    }
    if (g3 && g3 !== prevItems.current.g3 && !window.bundleAnimationTriggered) {
      newAnimated.g3 = true;
      setTimeout(() => setAnimatedItems(prev => ({ ...prev, g3: false })), 800);
    }
    if (rom && rom !== prevItems.current.rom && !window.bundleAnimationTriggered) {
      newAnimated.rom = true;
      setTimeout(() => setAnimatedItems(prev => ({ ...prev, rom: false })), 800);
    }

    if (Object.keys(newAnimated).some(key => newAnimated[key])) {
      setAnimatedItems(newAnimated);
    }
    prevItems.current = { credit, min, g3, rom };
    window.bundleAnimationTriggered = false;
  }, [credit, min, g3, rom]);

  useEffect(() => {
    if (numberIsChanged) {
      dispatch(setNumberChanged(false));
      !credit && clearSelected();
    }
  }, [numberIsChanged]);

  const onCreditRemove = () => {
    updateCreditQueue([]);
  };
  const remove3g = () => {
    sessionStorage.removeItem("Jawwal3g");
    setg3("");
  };
  const removeMin = () => {
    sessionStorage.removeItem("JawwalMin");
    setMin("");
  };

  const removeRom = () => {
    sessionStorage.removeItem("JawwalRom");
    setRom("");
  };

  const closeToast = (toastId) => {
    toast.dismiss(toastId); // Dismiss the specific toast
  };

  const charge = async (type) => {
    const isQuickly = type === "quickly";
    const creditQueuePayload = creditCards;
    const check = await chargeJawwal(
      {
        jawwalCreditQueue: creditQueuePayload,
        jawwal3g: g3 || null,
        jawwalRom: rom || null,
        jawwalCredit: credit || null,
        jawwalMin: min || null,
      },
      history,
      pushHistory,
      !isQuickly
    );
    if (check === "noBalance") {
      noBalanceCtx.openCardHandler();
      if (isQuickly) {
        throw new Error("quickly");
      }
    }
  };

  const onClickTypeCredit = async (e, type) => {
    e.preventDefault();
    queryParams.delete("number");
    if (type !== "quickly") {
      isLoading(true);
      await charge(type);
      pushHistory.push(`/`);
      getLastTransaction("0", 5);
      clearSelected();
      isLoading(false);
    } else {
      setQuickProcessLoading(true);
      ShowToastPromise(async () => await charge(type), {
        mobileNumber,
      });

      if (pathname.length > 1) {
        pathname.pop();
      }
      setQuickProcessLoading(false);
      clearSelected();
      const newPath = pathname.join("/");
      pushHistory.push(`${newPath}/undefined`);
    }
  };
  const clearSelected = () => {
    onCreditRemove();
    removeMin();
    remove3g();
    removeRom();
  };
  const mobileNumber = pathname?.[pathname.length - 1];
  const hasCreditSelection = creditCards.length > 0;
  const disabledButton =
    !/^\d{10}$/.test(mobileNumber) ||
    (numberFromQuery && mobileNumber !== numberFromQuery) ||
    loadingSpinner ||
    (!hasCreditSelection && !rom && !g3 && !min);

  const totalAmount =
    creditCards.reduce(
      (sum, item) => sum + (item?.price ? parseFloat(item.price) : 0),
      0
    ) +
    (rom?.price ? parseFloat(rom?.price) : 0) +
    (g3?.price ? parseFloat(g3?.price) : 0) +
    (min?.price ? parseFloat(min?.price) : 0);

  return (
    <div className="row">
      {loadingSpinner && <Spinner />}
      <div
        className={IS_MOBILE_DISPLAY ? "col-12" : "col-9"}
        style={{
          margin: "0 auto",
        }}
      >
        <div
          className={`card m-4s fixed-top1 position-sticky mt-2 ${isDarkTheme && "dark-background"
            }`}
          style={{
            padding: "10px 0 30px",
            minHeight: IS_MOBILE_DISPLAY ? "auto" : 170,
          }}
        >
          <div className="row mt-1 fixed-topx px-3">
            {IS_MOBILE_DISPLAY && (
              <div className="mt-2">
                <div
                  className={` ${isDarkTheme && "dark-background"}`}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0 10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "60%",
                    }}
                  >
                    <h5
                      className="text-muted mt-1 mb-2"
                      title="Balance"
                      style={{ fontSize: "1.2rem" }}
                    >
                      {translate("total")}:{" "}
                    </h5>
                    <h3 className="text-info">₪ {totalAmount}</h3>
                  </div>
                  <div>
                    <Button
                      type="submit"
                      disabled={disabledButton}
                      onClick={() => {
                        setOpenInfoModel(true);
                        setChargeType("normal");
                      }}
                      // title="accept"
                      variant="contained"
                      color="success"
                      startIcon={
                        <HourglassTopIcon sx={isRtL ? { mr: 1, ml: 1 } : {}} />
                      }
                      fullWidth
                      sx={{ marginBottom: 0.5 }}
                    >
                      {translate("accept")}
                    </Button>
                    <Button
                      type="submit"
                      disabled={disabledButton}
                      onClick={() => {
                        setChargeType("quickly");
                        setOpenInfoModel(true);
                      }}
                      variant="contained"
                      color="warning"
                      startIcon={
                        quickProcessLoading ? (
                          <CircularProgress size={24} sx={{ color: "white" }} />
                        ) : (
                          <BoltIcon sx={isRtL ? { mr: 1, ml: 1 } : {}} />
                        )
                      }
                      fullWidth
                    >
                      {quickProcessLoading ? null : translate("quickly")}
                    </Button>
                  </div>
                </div>
              </div>
            )}
            {creditCards.map((creditItem, index) => {
              const isLastCredit = index === creditCards.length - 1;
              const creditCardImage =
                creditItem.url ||
                "https://res.cloudinary.com/dtu4lltbk/image/upload/v1622203339/eced7efa-a16b-4fdd-9528-2c1f10356e1c_lzfhei.jpg";

              return (
                <div
                  key={creditItem.__uid || `${creditItem.id || "credit"}-${index}`}
                  ref={(el) => {
                    if (isLastCredit) {
                      cardRefs.current.credit = el;
                    }
                  }}
                  className={`col-lg-3 col-md-4 col-sm-4 mt-3`}
                  style={{
                    animation:
                      animatedItems.credit && isLastCredit
                        ? "bundleMove 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)"
                        : "none",
                    "--flip-transform": flipTransforms.credit,
                  }}
                >
                  <div
                    className={`card selected-bundle-card ${animatedItems.credit && isLastCredit
                      ? "selected-bundle-shimmer selected-bundle-pulse"
                      : ""
                      }`}
                  >
                    <div className="frame1">
                      <img
                        alt=""
                        src={creditCardImage}
                        width="260px"
                        height="100px"
                        loading="eager"
                        decoding="sync"
                      ></img>
                      {creditItem.flexiblePrice && (
                        <label className="text-abs">{creditItem.price}</label>
                      )}
                      <a
                        href
                        className="close-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          removeSingleCredit(creditItem.__uid);
                        }}
                      >
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
            {!isNil(min) && !isEmpty(min) && (
              <div
                ref={(el) => (cardRefs.current.min = el)}
                className={`col-lg-3 col-md-4 col-sm-4 mt-3`}
                style={{
                  animation: animatedItems.min ? 'bundleMove 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)' : 'none',
                  '--flip-transform': flipTransforms.min,
                }}
              >
                <div className={`card selected-bundle-card ${animatedItems.min ? 'selected-bundle-shimmer selected-bundle-pulse' : ''}`}>
                  <div className="frame1">
                    <img
                      alt=""
                      src={min.url}
                      width="260px"
                      height="100px"
                      loading="eager"
                      decoding="sync"
                    ></img>
                    {(min.renew === "True" || min.renew === "true") && (
                      <Badge text={translate("Renewable")}></Badge>
                    )}
                    <a href className="close-btn" onClick={removeMin}>
                      <i className="fa fa-times" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
            )}
            {!isNil(g3) && !isEmpty(g3) && (
              <div
                ref={(el) => (cardRefs.current.g3 = el)}
                className={`col-lg-3 col-md-4 col-sm-4 mt-3`}
                style={{
                  animation: animatedItems.g3 ? 'bundleMove 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)' : 'none',
                  '--flip-transform': flipTransforms.g3,
                }}
              >
                <div className={`card selected-bundle-card ${animatedItems.g3 ? 'selected-bundle-shimmer selected-bundle-pulse' : ''}`}>
                  <div className="frame1">
                    <img
                      alt=""
                      src={g3.url}
                      width="260px"
                      height="100px"
                      loading="eager"
                      decoding="sync"
                    ></img>
                    {(g3.renew === "True" || g3.renew === "true") && (
                      <Badge text={translate("Renewable")}></Badge>
                    )}
                    <a href className="close-btn">
                      <i
                        className="fa fa-times"
                        aria-hidden="true"
                        onClick={remove3g}
                      ></i>
                    </a>
                  </div>
                </div>
              </div>
            )}
            {!isNil(rom) && !isEmpty(rom) && (
              <div
                ref={(el) => (cardRefs.current.rom = el)}
                className={`col-lg-3 col-md-4 col-sm-4 mt-3`}
                style={{
                  animation: animatedItems.rom ? 'bundleMove 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)' : 'none',
                  '--flip-transform': flipTransforms.rom,
                }}
              >
                <div className={`card selected-bundle-card ${animatedItems.rom ? 'selected-bundle-shimmer selected-bundle-pulse' : ''}`}>
                  <div className="frame1">
                    <img
                      alt=""
                      src={rom.url}
                      width="260px"
                      height="100px"
                      loading="eager"
                      decoding="sync"
                    ></img>
                    <a href className="close-btn" onClick={removeRom}>
                      <i className="fa fa-times" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {!IS_MOBILE_DISPLAY && (
        <div className="col-3">
          <div className="card total-balance-card mt-2">
            <div
              className={`card-body p-2 ${isDarkTheme && "dark-background"}`}
            >
              <h5
                className="text-muted mt-1 mb-2"
                title="Balance"
                style={{ fontSize: "1.2rem" }}
              >
                {translate("total")}
              </h5>
              <h3 className="text-info mt-2">
                ₪{" "}
                {(credit?.price ? parseFloat(credit?.price) : 0) +
                  (rom?.price ? parseFloat(rom?.price) : 0) +
                  (g3?.price ? parseFloat(g3?.price) : 0) +
                  (min?.price ? parseFloat(min?.price) : 0)}
              </h3>

              <Button
                type="submit"
                disabled={disabledButton}
                onClick={() => {
                  setOpenInfoModel(true);
                  setChargeType("normal");
                }}
                // title="accept"
                variant="contained"
                color="success"
                startIcon={
                  <HourglassTopIcon sx={isRtL ? { mr: 1, ml: 1 } : {}} />
                }
                fullWidth
                sx={{ marginBottom: 0.5 }}
              >
                {translate("accept")}
              </Button>
              <Button
                type="submit"
                disabled={disabledButton}
                onClick={(e) => {
                  setChargeType("quickly");
                  setOpenInfoModel(true);
                }}
                variant="contained"
                color="warning"
                startIcon={
                  quickProcessLoading ? (
                    <CircularProgress size={24} sx={{ color: "white" }} />
                  ) : (
                    <BoltIcon sx={isRtL ? { mr: 1, ml: 1 } : {}} />
                  )
                }
                fullWidth
              >
                {quickProcessLoading ? null : translate("quickly")}
              </Button>
            </div>
          </div>
        </div>
      )}
      <ConfirmModal
        phoneNumber={mobileNumber}
        selectedCards={selectedCards}
        open={openInfoModel}
        handleConfirm={(e) => {
          setOpenInfoModel(false);
          onClickTypeCredit(e, chargeType);
        }}
        handleClose={() => setOpenInfoModel(false)}
        totalAmount={totalAmount}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isDarkTheme: state.darkTheme.isDarktheme,
});

export default connect(mapStateToProps, { chargeJawwal })(Selected);
